import { NavLink, useNavigate } from 'react-router-dom';
import Image from '@/components/atoms/Image';
import NotFoundImg from '@/assets/illustrations/404-illustration.svg';
import { Button, buttonVariants } from '@/components/ui/button';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import Routes from '@/router/routes';

function Error404Page() {
  const navigate = useNavigate();

  const redirection = () => {
    navigate(Routes.super_admin_dashboard.path);
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      <NavLink to="/dashboard">
        <Image src={TelletLogo} alt="logo" className="absolute w-24 h-fit top-5 left-5" />
      </NavLink>
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <Image
          effect="blur"
          src={NotFoundImg}
          alt="illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">Something missing</h1>
        <p className="mt-2 text-lg font-medium text-light-dark">
          This page is unavailable or does not exist.
        </p>
        <Button
          onClick={redirection}
          className={buttonVariants({
            variant: 'default',
            className: 'mt-5 transition-all ease-in-out hover:!bg-darker-primary',
          })}
        >
          Back to home
        </Button>
      </div>
    </div>
  );
}

export default Error404Page;
